import {
  create,
  NConfigProvider,  // 👈 ADICIONE ESTA LINHA
  NButton,
  NCard,
  NLayout,
  NLayoutHeader,
  NLayoutSider,
  NLayoutContent,
  NMenu,
  NIcon,
  NSwitch,
  NMessageProvider,
  NDialogProvider,
  NNotificationProvider,
  NInput,         
  NDataTable,     
  NForm,          
  NFormItem,      
  NDatePicker,    
  NSpace,         
  NModal,
  NUpload,
  NRadio,
  NSelect,
  NTag,
  NList,
  NListItem,
  NThing
} from 'naive-ui'

export const naive = create({
  components: [
    NConfigProvider,  // 👈 E AQUI TAMBÉM
    NButton,
    NCard,
    NLayout,
    NLayoutHeader,
    NLayoutSider,
    NLayoutContent,
    NMenu,
    NIcon,
    NSwitch,
    NMessageProvider,
    NDialogProvider,
    NNotificationProvider,
    NInput,
    NDataTable,
    NForm,
    NFormItem,
    NDatePicker,
    NSpace,
    NModal,
    NUpload,
    NRadio,
    NSelect,
    NTag,
    NList,
    NListItem,
    NThing
  ]
})
